import React, { useCallback } from "react";
import { EditorAttachment } from "../EditorAttachment/EditorAttachment";
export const AttachmentNodeView = ({ view, attrs, getPos, service, }) => {
    const handleUpload = useCallback((url) => {
        service
            .uploadByUrl(url)
            .then((file) => {
            view.dispatch(view.state.tr.setNodeMarkup(getPos(), null, {
                file,
                url: null,
            }));
        })
            .catch((err) => {
            console.error("Error uploading file", err);
        });
    }, [service, view, getPos]);
    return (React.createElement(EditorAttachment, { attrs: attrs, service: service, onUpload: handleUpload }));
};
